export default __webpack_public_path__ + "static/media/high_priority_banner.71f11e85.svg";